import { type FC } from "react";
import { useCallCenterShift } from "../../contexts/CallCenterShiftProvider";
import { useUser } from "../../contexts/UserProvider";
import {
  CallCenterBriefing,
  CallCenterFarewell,
  CallCenterGoalScreen,
  CallCenterShiftLogin,
  CallCenterStationLoading,
} from "./CallCenterEntry";
import { CallCenterVolunteerApp } from "./CallCenterVolunteerApp";

export const CallCenterRoot: FC = () => {
  const { currentUser } = useUser();
  const { isStation, workbench, loading, farewell, setFarewell } = useCallCenterShift();

  if (currentUser?.isCallCenterStation || isStation) {
    if (loading && !farewell) {
      return <CallCenterStationLoading />;
    }
    if (!workbench && farewell) {
      return <CallCenterFarewell message={farewell} onClose={() => setFarewell(null)} />;
    }
    if (!workbench) return <CallCenterShiftLogin />;
    if (!workbench.shift.briefingSeenAt) return <CallCenterBriefing />;
    if (!workbench.shift.goalSeenAt) return <CallCenterGoalScreen />;
    return <CallCenterVolunteerApp />;
  }

  return null;
};
